import { styled } from '@mui/material/styles';
import { Select } from '@components/Select';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { PLACEHOLDER_CONTEXT, getPlaceholdersForContext } from '@constants/placeholders';
import { WA_MAPPING_SOURCE } from '@constants/campaignTemplates';

const Row = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'minmax(80px, 140px) 1fr',
    gap: 12,
    alignItems: 'start',
});

const CONTACT_TOKENS = ['name', 'last_name'];

const VariablesTable = ({ mappings, onChange, disabled }) => {
    const { t } = useTranslation();

    const placeholders = getPlaceholdersForContext(PLACEHOLDER_CONTEXT.CAMPAIGN);
    const toOption = placeholder => ({ value: placeholder.token, label: t(placeholder.labelKey) });
    const groupedOptions = [
        {
            group: t('TemplateLibrary.waGroupContact'),
            children: placeholders.filter(p => CONTACT_TOKENS.includes(p.token)).map(toOption),
        },
        {
            group: t('TemplateLibrary.waGroupLocation'),
            children: placeholders.filter(p => !CONTACT_TOKENS.includes(p.token)).map(toOption),
        },
    ];

    const rows = mappings.filter(mapping => mapping.source !== WA_MAPPING_SOURCE.LINK_SLOT);
    if (rows.length === 0) return null;

    const patchMapping = (param, patch) =>
        onChange(mappings.map(mapping => (mapping.param === param ? { ...mapping, ...patch } : mapping)));

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Typography variant="subtitle2">{t('TemplateLibrary.waVariables')}</Typography>
            {rows.map(mapping => (
                <Row key={mapping.param}>
                    <Typography variant="body2" sx={{ paddingTop: '12px', wordBreak: 'break-all' }}>
                        {`{{${mapping.param}}}`}
                    </Typography>
                    <Select
                        fullWidth
                        groupBased
                        label={t('TemplateLibrary.waResolution')}
                        disabled={disabled}
                        value={mapping.token}
                        onChange={({ target: { value } }) =>
                            patchMapping(mapping.param, { source: WA_MAPPING_SOURCE.FIELD, token: value })
                        }
                        options={groupedOptions}
                    />
                </Row>
            ))}
        </div>
    );
};

export default VariablesTable;
